import { useNavigate } from 'react-router-dom';
import { IncidentOverview } from './IncidentOverview';
import { useIncidentOverview } from '@/app/hooks/incident/useIncidentOverview';
import { useIncidentStatusTransition } from '@/app/hooks/incident/useIncidentStatusTransition';

export function IncidentOverviewContainer() {
  const navigate = useNavigate();
  const {
    blockingReason,
    cancelPendingTransition,
    confirmBlockedTransition,
    incidents,
    error,
    isTransitionDialogOpen,
    isTransitioning,
    isFetching,
    isLoading,
    pendingTransition,
    pagination,
    requestTransition,
    searchValue,
    setBlockingReason,
    handleSearchChange,
    handleTableChange,
    refetch,
    transitioningIncidentId,
  } = {
    ...useIncidentOverview(),
    ...useIncidentStatusTransition(),
  };

  return (
    <IncidentOverview
      incidents={incidents}
      errorMessage={error?.message ?? null}
      isFetching={isFetching}
      isLoading={isLoading}
      isTransitionDialogOpen={isTransitionDialogOpen}
      isTransitioning={isTransitioning}
      pagination={pagination}
      pendingTransition={pendingTransition}
      searchValue={searchValue}
      blockingReason={blockingReason}
      onBlockingReasonChangeAction={setBlockingReason}
      onCancelTransitionAction={cancelPendingTransition}
      onConfirmTransitionAction={() => {
        void confirmBlockedTransition();
      }}
      onIncidentSelectAction={(incidentId) =>
        navigate(`/incidents/${incidentId}`)
      }
      onRefreshAction={() => {
        void refetch();
      }}
      onSearchChangeAction={handleSearchChange}
      onTableChangeAction={handleTableChange}
      onTransitionAction={requestTransition}
      transitioningIncidentId={transitioningIncidentId}
    />
  );
}
